import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-home-base-lined",
  "use": "rt-base-home-base-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-home-base-lined\"><path d=\"M902.8 445.4L534.7 97c-6-6-14.9-9-23.9-9-8.9 0-17.9 3-23.8 9L121 445.4c-11.9 12-11.9 36 0 48.1h59.7c11.9 0 21.9 10 21.9 22V904c0 18 15.9 32 35.8 32h139v0.3h288v-0.3h122.1c19.9 0 35.8-16 35.8-32V513.5c0-12 9.9-22 21.9-22h59.7c9.8-14 9.8-34.1-2.1-46.1zM593.4 864h-144V708.3c0-39.7 32.3-72 72-72s72 32.3 72 72V864z m184.2-415.7c-16.3 16.9-26.3 39.9-26.3 65.1V848c0 8.8-7.2 16-16 16h-69.9V708.3c0-79.4-64.6-144-144-144s-144 64.6-144 144V864h-86.8c-8.8 0-16-7.2-16-16V515.5c0-26.3-10.8-50-28.2-67.1-6.5-6.4-6.5-16.8 0.1-23.1l264.4-251.7 266.2 251.9c6.5 6.1 6.6 16.3 0.5 22.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/home-base-lined.svg
// module id = 1716
// module chunks = 228